export class GetClientIdentityModel {

    public identityType: string;
    public identityValue: string;
}
